/**
 * La barra inferior del celular (Mati, 2026-11-03: como la de WhatsApp): una píldora flotante con una burbuja
 * detrás de la sección activa. Manteniendo apretado, la burbuja sigue al dedo y al soltar va a donde quedó.
 * Acá, la cuenta de en qué botón cae el dedo y dónde se dibuja la burbuja (en px desde el borde izquierdo).
 */

/** Cuánto hay que mantener apretado para arrastrar la burbuja (ms). */
export const MANTENER_MS = 280;

/** Si el dedo se mueve más que esto (px) antes de MANTENER_MS, es un toque o un scroll, no un arrastre. */
export const TOLERANCIA_PX = 10;

/** El botón (0…n-1) bajo la posición `x` de una barra de `ancho` px con `n` botones iguales. */
export function indiceEn(x: number, ancho: number, n: number): number {
  if (n <= 0 || ancho <= 0) return 0;
  return Math.min(n - 1, Math.max(0, Math.floor(x / (ancho / n))));
}

/** El borde izquierdo de la burbuja (del ancho de un botón) centrada en `x`, sin salirse de la barra. */
export function posicionBurbuja(x: number, ancho: number, n: number): number {
  if (n <= 0 || ancho <= 0) return 0;
  const boton = ancho / n;
  return Math.min(ancho - boton, Math.max(0, x - boton / 2));
}
